import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getBusinessDateString, parseBusinessDate } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { isToday } from 'date-fns';
import { DisplayText } from '../../../../display-text';
const b = bemClassBuilder('v-screening-date-dropdown-option');
const defaultScreeningDateFormat = '${date|d|ddd D MMMM}';
export const ScreeningDateDropdownOptionTemplate = props => {
    const { text, todayLabel } = props;
    return (_jsxs("div", Object.assign({ className: b.block() }, { children: [_jsx("span", Object.assign({ className: b.element('screening-date') }, { children: text })), _jsx(DisplayText, { label: todayLabel })] })));
};
ScreeningDateDropdownOptionTemplate.displayName = 'ScreeningDateDropdownOptionTemplate';
export const ScreeningDatePreviewDropdownOptionTemplate = props => {
    const { todayLabel, text } = props;
    return (_jsxs("div", Object.assign({ className: b.block({ preview: true }) }, { children: [_jsx("span", Object.assign({ className: b.element('screening-date') }, { children: text })), _jsx(DisplayText, { label: todayLabel })] })));
};
ScreeningDatePreviewDropdownOptionTemplate.displayName = 'ScreeningDatePreviewDropdownOptionTemplate';
export const getDropdownOptionsForScreeningDates = (screeningDates, i18n, config) => {
    return screeningDates.map(date => {
        const businessDate = parseBusinessDate(date.businessDate);
        return {
            text: i18n.template((config === null || config === void 0 ? void 0 : config.screeningDateFormat) || defaultScreeningDateFormat, {
                date: businessDate
            }),
            value: getBusinessDateString(businessDate),
            todayLabel: isToday(businessDate) ? config === null || config === void 0 ? void 0 : config.todayLabel : undefined
        };
    });
};
